import keyMirror from 'keymirror';

export default {
  Auth: keyMirror({
    setAuthData: null,
    logout: null,
    login: null,
  }),
  RateQuote: keyMirror({
    updateDateRange: null,
    updateDateString: null,
    toggleDatePicker: null,
    updateString: null,
  }),
  Responsive: keyMirror({
    updateWindowWidth: null,
    updateWindowHeight: null,
  }),
  Inquiry: keyMirror({
    toggleNewTraveler: null,
    addTraveler: null,
    moveTraveler: null,
    removeTraveler: null,
    removeSegment: null,
    updateField: null,
    addSegment: null,
    resetInquiryForm: null,
  }),
  Trips: keyMirror({
    setValue: null,
  }),
};



// WEBPACK FOOTER //
// /src/store/ActionTypes.js